import { css } from 'lit'

// Shared styling for the unauthenticated auth pages (login, register, reset,
// verify) so they present as one centered card. Design tokens (--bx-*) come from
// index.html and pierce the shadow DOM.
export const authCardStyles = css`
  :host { display: flex; justify-content: center; align-items: flex-start; padding-top: 6vh; }
  .card {
    background: var(--bx-surface); border: 1px solid var(--bx-border);
    border-radius: var(--bx-radius); box-shadow: var(--bx-shadow);
    padding: 2.25rem; max-width: 400px; width: 100%;
  }
  h1 { margin: 0 0 0.25rem; color: var(--bx-brand); font-size: 1.4rem; }
  .sub { color: var(--bx-muted); margin: 0 0 1.5rem; }
  form { display: flex; flex-direction: column; gap: 0.9rem; }
  label { display: flex; flex-direction: column; gap: 0.3rem; font-size: 0.85rem;
          font-weight: 600; color: var(--bx-ink); }
  input {
    font: inherit; padding: 0.6rem 0.7rem; border: 1px solid var(--bx-border);
    border-radius: var(--bx-radius); background: var(--bx-bg); color: var(--bx-ink);
  }
  input:focus { outline: 2px solid var(--bx-accent); border-color: transparent; }
  button.primary {
    margin-top: 0.3rem; font: inherit; font-weight: 700; cursor: pointer;
    padding: 0.65rem 1rem; border: none; border-radius: var(--bx-radius);
    background: var(--bx-accent); color: var(--bx-accent-ink);
  }
  button.primary:disabled { opacity: 0.6; cursor: default; }
  .links { display: flex; justify-content: space-between; margin-top: 1rem; font-size: 0.85rem; }
  .links a, .dev a { color: var(--bx-brand); cursor: pointer; text-decoration: none; }
  .links a:hover, .dev a:hover { text-decoration: underline; }
  .divider { display: flex; align-items: center; gap: 0.75rem; margin: 1.5rem 0 1rem;
             color: var(--bx-muted); font-size: 0.75rem; text-transform: uppercase; letter-spacing: 0.5px; }
  .divider::before, .divider::after { content: ''; flex: 1; height: 1px; background: var(--bx-border); }
  a.google {
    display: flex; align-items: center; justify-content: center; gap: 0.6rem;
    text-decoration: none; padding: 0.65rem 1rem; border: 1px solid var(--bx-border);
    border-radius: var(--bx-radius); color: var(--bx-ink); font-weight: 600; background: var(--bx-surface);
  }
  a.google:hover { background: var(--bx-bg); }
  .g { width: 18px; height: 18px; background: #fff; border: 1px solid var(--bx-border);
       border-radius: 3px; display: grid; place-items: center; color: #4285F4; font-weight: 700; font-size: 12px; }
  .dev { text-align: center; margin: 1rem 0 0; font-size: 0.85rem; }
  .error { background: #fdeaea; color: #a61b1b; border: 1px solid #f3c4c4;
           border-radius: var(--bx-radius); padding: 0.6rem 0.8rem; margin: 0 0 1.25rem; font-size: 0.85rem; }
  .success { background: #edf7ed; color: #1e5e20; border: 1px solid #c6e6c7;
             border-radius: var(--bx-radius); padding: 0.9rem; font-size: 0.9rem; }
  .muted { color: var(--bx-muted); font-size: 0.9rem; }
`
